// extracted by mini-css-extract-plugin
export default {"diarySection":"Home_diarySection__qpj8w"};